<astrea-internal-banner
    title="{{ 'navigation.login' | translate }}"
></astrea-internal-banner>

<div class="d-flex j-c-around a-i-center content-height m-sm-4 m-xs-2 m-2">

    <div class="hide-mobile background-left">
        <img class="img-responsive" src="/assets/images/illustrations/Illustration-login-1.png" alt="Joven mujer leyendo un libro en un sofá.">
    </div>

    <div class="astrea-box astrea-login">

        <mat-card *ngIf="!forgotPassword; else TplForgotPassword" class="p-1">
            <mat-card-title>
                <div class="astrea-subtitle">
                    <h2 class="register-title">{{ 'navigation.login' | translate }}</h2>
                </div>
            </mat-card-title>
            <mat-card-content>
                <form [formGroup]="formLogin" (ngSubmit)="loginUser()">
                    <div class="login-error my-2" *ngIf="loginError">
                        <h2>{{ 'login.error' | translate }}</h2>
                    </div>
                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'login.email' | translate }}</mat-label>
                        <input type="email" matInput formControlName="user">
                        <mat-icon matSuffix>email</mat-icon>
                        <mat-error>{{ 'login.email_err' | translate }}</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'login.password' | translate }}</mat-label>
                        <input [type]="hide ? 'password' : 'text'" matInput formControlName="pass">
                        <button type="button" mat-icon-button matSuffix (click)="changeTypePass()" attr.aria-label="{{ 'login.see_password' | translate }}" [attr.aria-pressed]="hide" tabindex="-1">
                            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error>{{ 'login.password_err' | translate }}</mat-error>
                    </mat-form-field>
                    <button *ngIf="!loading" class="btn btn-green mt-3 w-100" mat-button>
                        {{ 'login.sing_in' | translate }}
                    </button>
                    <button *ngIf="loading" class="btn btn-green mt-3 w-100" mat-button>
                        <astrea-loading></astrea-loading>
                    </button>

                    <div class="astrea-account d-flex j-c-center a-i-start mt-3">
                        <mat-icon style="overflow: visible;">help_outline</mat-icon>
                        <p>
                            {{ 'login.accounts' | translate }} <a href="https://astreavirtual.com" target="_blank">astreavirtual.com</a>
                        </p>
                    </div>

                </form>
            </mat-card-content>
            <mat-card-actions class="t-center p-0">
                <button class="forgot-pass login-link px-2" (click)="forgotPasswordChange()" mat-flat-button>
                    <span>
                        {{ 'login.forgot_pass' | translate }}
                    </span>
                </button>
                <hr class="m-0 mx-2">
                <a [routerLink]="['/register']" [queryParams]="{ redirect: redirect }" class="b-register login-link px-2" mat-flat-button>
                    <span>
                        {{ 'login.sing_up' | translate }}
                    </span>
                </a>
            </mat-card-actions>
        </mat-card>

        <ng-template #TplForgotPassword>
            <mat-card class="p-2">
                <mat-card-header>
                    <mat-card-title class="astrea-subtitle">
                        <h2 class="login-title">{{ 'login.recover_pass' | translate }}</h2>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <p>{{ 'login.recover_txt_1' | translate }}</p>
                        <p>{{ 'login.recover_txt_2' | translate }}</p>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="formForgotPass" (ngSubmit)="handleForgotPass()">
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'login.email' | translate }}</mat-label>
                            <input type="email" matInput formControlName="email">
                            <mat-icon matSuffix>email</mat-icon>
                            <mat-error>{{ 'login.email_err' | translate }}</mat-error>
                        </mat-form-field>
                        <button *ngIf="!loading" class="btn btn-green mt-3 w-100" mat-button>
                            {{ 'login.recover_button' | translate }}
                        </button>
                        <button *ngIf="loading" class="btn btn-green mt-3 w-100" mat-button>
                            <astrea-loading></astrea-loading>
                        </button>
                    </form>
                </mat-card-content>
                <mat-card-actions>
                    <button class="forgot-pass login-link p-2" (click)="forgotPasswordChange()" mat-flat-button>
                        <span>
                            {{ 'login.return_login' | translate }}
                        </span>
                    </button>
                </mat-card-actions>
            </mat-card>
        </ng-template>

    </div>

    <div class="hide-mobile background-right">
        <img class="img-responsive" src="/assets/images/illustrations/Illustration-login-2.png" alt="Joven mujer trabajando con una computadora portatil.">
    </div>

</div>
